import { render, staticRenderFns } from "./VisitAdd.vue?vue&type=template&id=10bef9d0&scoped=true&"
import script from "./VisitAdd.vue?vue&type=script&lang=js&"
export * from "./VisitAdd.vue?vue&type=script&lang=js&"
import style0 from "./VisitAdd.vue?vue&type=style&index=0&id=10bef9d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bef9d0",
  null
  
)

export default component.exports